//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: ["groupCtrl"],
  data() {
    return {
      selectedRule: "",
      rules: this.groupCtrl.rules,
    };
  },
  watch: {
    selectedRule(newValue) {
      if (newValue) {
        //emit the selected rule to the parent component
        this.$emit("add-rule", newValue);
      }
    },
  },
  computed: {
    addRuleBtnClass() {
      if (this.selectedRule) {
        return ["hover:bg-blue-700"];
      }

      return ["opacity-50", "cursor-not-allowed"];
    },
  },
  methods: {
    addRule() {
      this.groupCtrl.addRule(this.selectedRule);
      this.selectedRule = "";
    },
    filterFnByName(val, update) {
      update(() => {
        const needle = val.toLowerCase();
        this.rules = this.groupCtrl.rules.filter(
          (v) => v.name.toLowerCase().indexOf(needle) > -1
        );
      });
    },
  },
};
